const translations = {
    'form.checkbox.label.allow_uppercase_letters' : {
        'de' : 'Großbuchstaben',
    },
    'form.checkbox.label.allow_lowercase_letters' : {
        'de' : 'Kleinbuchstaben',
    },
    'form.checkbox.label.easy_to_remember' : {
        'de' : 'Aussprechbar',
    },
    'form.checkbox.label.allow_umlauts' : {
        'de' : 'Umlaute',
    },
    'form.checkbox.label.allow_zeros' : {
        'de' : 'Nullen',
    },
    'form.checkbox.label.allow_numbers' : {
        'de' : 'Nummern',
    },
    'form.checkbox.label.allow_special_characters' : {
        'de' : 'Sonderzeichen',
    },
    'form.checkbox.label.allowed_special_characters' : {
        'de' : 'Erlaubte',
    },
    'form.checkbox.hint.allow_uppercase_letters' : {
        'de' : 'z.B. ABCDEF',
    },
    'form.checkbox.hint.allow_lowercase_letters' : {
        'de' : 'z.B. abcdef',
    },
    'form.checkbox.hint.easy_to_remember' : {
        'de' : 'z.B. batoja',
    },
    'form.checkbox.hint.allow_umlauts' : {
        'de' : 'z.B. äüöÄÜÖ',
    },
    'form.checkbox.hint.allow_zeros' : {
        'de' : 'z.B. 0',
    },
    'form.checkbox.hint.allow_numbers' : {
        'de' : 'z.B. 12345',
    },
    'form.checkbox.hint.allow_special_characters' : {
        'de' : 'z.B. !§$%&',
    },
    'form.dropdown.placeholder.default' : {
        'de' : 'Wählen Sie eine Option...',
    },
    'form.range.label.number_of_passwords' : {
        'de' : '%number% Passwörter',
    },
    'form.range.title.safety_level' : {
        'de' : '<span class="hidden-mobile">1. </span>Wählen Sie Ihr Sicherheitslevel',
    },
    'form.range.label.number_of_passwords_singular' : {
        'de' : '%number% Passwort',
    },
    'form.range.label.number_of_character' : {
        'de' : '%character% Zeichen',
    },
    'form.range.hint.password_strength' : {
        'de' : 'knackbar in %time%',
    },
    'form.button.label.generate_password' : {
        'de' : '%passwordString% generieren',
    },
    'passwords.result.title': {
        'de' : 'Ihr Passwort lautet',
    },
    'passwords.result.title.plural': {
        'de' : 'Ihre %number% Passwörter lauten',
    },
    'expandable.label.expert_settings' : {
        'de' : '<span class="hidden-mobile">2. </span>Einstellungen anpassen <span class="hidden-mobile">(optional)</span>',
    },
    'measurement_unit.time.years': {
        'de' : 'Jahren'
    },
    'measurement_unit.time.months': {
        'de' : 'Monaten'
    },
    'measurement_unit.time.days': {
        'de' : 'Tagen'
    },
    'measurement_unit.time.hours': {
        'de' : 'Stunden'
    },
    'measurement_unit.time.minutes': {
        'de' : 'Minuten'
    },
    'measurement_unit.time.seconds': {
        'de' : 'Sekunden'
    },
    'measurement_unit.time.year': {
        'de' : 'Jahr'
    },
    'measurement_unit.time.month': {
        'de' : 'Monat'
    },
    'measurement_unit.time.day': {
        'de' : 'Tag'
    },
    'measurement_unit.time.hour': {
        'de' : 'Stunde'
    },
    'measurement_unit.time.minute': {
        'de' : 'Minute'
    },
    'measurement_unit.time.second': {
        'de' : 'Sekunde'
    },
    'header.title': {
        'de' : 'Jetzt sicheres Passwort generieren',
    },
    'footer.label.safety_hint': {
        'de' : 'Absolute Vertraulichkeit: die Passwörter werden ausschließlich auf Ihrem Gerät generiert und nicht von uns gespeichert.',
    },
    'footer.label.powered_by': {
        'de' : 'Powered by',
    },
    'notification.text.options_checked': {
        'de' : 'Es muss mindestens eine der Optionen ausgwählt sein.',
    },
    'form.builder.label.options_color': {
        'de' : 'Optionenfarbe',
    },
    'form.builder.label.headline_color': {
        'de' : 'Titelfarbe',
    },
    'form.builder.label.title_color': {
        'de' : 'Überschriftenfarbe',
    },
    'form.builder.label.button_background_color': {
        'de' : 'Button-Hintergrundfarbe',
    },
    'form.builder.label.button_text_color': {
        'de' : 'Button-Textfarbe',
    },
    'form.builder.label.background_color': {
        'de' : 'Hintergrundfarbe',
    },
    'form.builder.label.border_color': {
        'de' : 'Rahmenfarbe',
    },
    'form.builder.label.expert_settings_true': {
        'de' : 'Ja',
    },
    'form.builder.label.expert_settings_false': {
        'de' : 'Nein',
    },
    'form.label.title_generate_widget': {
        'de' : '1. Widget generieren',
    },
    'form.label.copy_widget_code': {
        'de' : '2. Erzeugten Code einbauen',
    },
    'form.label.show_expert_settings': {
        'de' : 'Experteneinstellungen anbieten',
    },
    'form.button.label.generate_widget_code': {
        'de' : 'Widget-Code generieren',
    },
    'alert.copied_password' : {
        'de' : 'In Zwischenablage kopiert!',
    },
    'form.label.embed_code_area' : {
        'de' : 'Bauen Sie den folgenden HTML Code auf Ihrer Webseite ein:'
    },
    'builder.title': {
        'de' : 'Whitelabel Widget',
    },
    'builder.preview_title': {
        'de' : 'Widget Vorschau',
    },
    'settings.tooltip.settings_hint': {
        'de' : 'Personalisieren Sie Ihr Passwort indem Sie bestimmte Zeichengruppen dazu- oder wegnehmen. Hier können Sie auch angeben, wieviele Passwörter Sie generieren möchten.',
    },
    'form.tooltip.security_hint': {
        'de' : 'Es handelt sich hier um einen groben Richtwert. Die eigentliche Zeitberechnung hängt vom Kontext ab, und lässt daher keine allgemeingültige Einschätzung zu.',
    }
}

export default translations



// WEBPACK FOOTER //
// ./src/config/translations.js